import { SalesforceConfigRender } from './salesforce'

declare const RASA_SELF_SERVICE_API: string

export class FontevaConfigRender extends SalesforceConfigRender {
  
}
